import { axios } from '@Root/API'

export const get = (id, page) => {
  return axios.get(`contact/${id}/attachment`, {
    params: {
      page,
    },
  })
}
